import type { ChartTheme } from './index';

export const darkTheme: ChartTheme = {
  background: '#131722',
  gridColor: 'rgba(255, 255, 255, 0.06)',
  axisTextColor: '#787b86',
  axisBorderColor: '#363a45',
  crosshairColor: '#787b86',
  tooltipBackground: '#1e222d',
  tooltipBorder: '#363a45',
  tooltipText: '#d1d4dc',
  candleUpColor: '#26a69a',
  candleDownColor: '#ef5350',
  candleUpBorderColor: '#26a69a',
  candleDownBorderColor: '#ef5350',
  textColor: '#d1d4dc',
  textSecondary: '#787b86',
};
